import { DhlCard as NewCard } from "@dhl-official/react-library";
import PropTypes from "prop-types";

import React from "react";

/**
 * Migration wrapper for Card component
 * This component helps transition from old UI library to new UI library
 * by handling prop mapping and maintaining backward compatibility
 */
export const Card = (props) => {
  const { children, ...rest } = props;

  return <NewCard {...rest}>{children}</NewCard>;
};

Card.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Card;
